var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBillingYellowPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66683 9.66536V0.332031H9.66683V9.66536H5.66683ZM0.333496 9.66536V0.332031H4.3335V9.66536H0.333496ZM7.00016 8.33203H8.3335V1.66536H7.00016V8.33203ZM1.66683 8.33203H3.00016V1.66536H1.66683V8.33203Z",
    fill: "#C06D1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBillingYellowPause);
export default __webpack_public_path__ + "static/media/icon-billing-yellow-pause.7f9dae625b5f5647cc40c0caaa1bfac2.svg";
export { ForwardRef as ReactComponent };